import { render, staticRenderFns } from "./TouchpointOverview.vue?vue&type=template&id=a89b3e18&scoped=true&"
import script from "./TouchpointOverview.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverview.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/Shared/tabbed-menu.scss?vue&type=style&index=0&id=a89b3e18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b3e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a89b3e18')) {
      api.createRecord('a89b3e18', component.options)
    } else {
      api.reload('a89b3e18', component.options)
    }
    module.hot.accept("./TouchpointOverview.vue?vue&type=template&id=a89b3e18&scoped=true&", function () {
      api.rerender('a89b3e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/TouchpointOverview.vue"
export default component.exports